import type { ReactElement } from 'react';

import { ProjectOverview } from '../components/project-overview';
import { useProjectStore } from '../store/project-store';

/** 可列印的單頁專案狀態總覽；macOS 列印面板可直接另存 PDF。 */
export function ProjectOverviewView(): ReactElement {
  const project = useProjectStore((state) => state.project);
  return (
    <div className="h-full overflow-auto rounded border border-slate-200 dark:border-slate-700" data-testid="project-overview-view">
      <ProjectOverview project={project} onPrint={() => window.print()} />
    </div>
  );
}
